<template>
  <v-app fluid>
    <NavComponent></NavComponent>
    <v-main fluid class="primary fill-height" v-if="ready">
      <router-view />
    </v-main>
    <FooterComponent></FooterComponent>
  </v-app>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import NavComponent from '@/components/Nav.vue'
import FooterComponent from '@/components/Footer.vue'
import { mapState } from 'vuex'
import { sleep } from './utils/general'
import { useRouter, useRoute } from 'vue-router'


// import { useTheme } from 'vuetify'
// const theme = useTheme()
// theme.global.name.value = 'synthWave'

const redirectOff = ['/sign-in', '/register', '/', '/subscribe']

@Options({
  computed: {
    ...mapState(['authenticated'])
  },
  watch: {
    async authenticated(value: boolean | null) {
      if (this.ready) {
        return
      }
      if (!value && !redirectOff.includes(this.$route.path)) {
        console.log('redirect to home page.', this.$route.path)
        this.$router.push('/')
      }
      await sleep(150)
      this.ready = true
    }
  },
  components: {
    NavComponent,
    FooterComponent
  },
})
export default class App extends Vue {
  authenticated!: boolean | null
  ready: boolean = false
  route = useRoute()
  router = useRouter()

  async mounted() {
    await this.$store.dispatch('checkAuth')
    await sleep(500)
    this.checkPath()
    // try one more time just in case, slow connection maybe
    await sleep(1000)
    this.checkPath()
  }

  checkPath() {
    if (this.ready) {
      return
    }
    if (redirectOff.includes(this.route.path) && !this.authenticated) {
      this.ready = true
      console.log('do not redirect to sign in', this.route.path)
    } else if (!redirectOff.includes(this.route.path) && !this.authenticated)  {
      console.log('redirect to sign in', this.route.path)
      this.ready = true
      this.router.push('/sign-in')
    }
  }
}
  
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  // height: 100%;
}

.align-right {
  text-align: right;
}

.max-height-75px {
  max-height: 75px;
}

.max-width-100 {
  max-width: 100%;
}
.max-width-1250 {
  max-width: 1250px;
  margin-left: auto;
  margin-right: auto;
}
.primary {
  // background-color: #4e221b;
  margin-bottom: -32px;
}
// .full-height {
//   height: 100%;
// }
a:-webkit-any-link {
  color: rgb(var(--v-theme-primary));
  &:visited {
    color: rgb(var(--v-theme-primary));
  }
}

</style>
